import React, { Component } from 'react';
import './Answers.scss';
import { required, numericality } from 'redux-form-validators';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AnswerInput from './AnswerInput';
import classNames from 'classnames';
import {toastr} from 'react-redux-toastr'
import PropTypes from 'prop-types'


const ErrorMessage = ({meta: { touched, error }}) => (touched && (error && <div className="error-message">{error}</div> || null) || null);


class Answers extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  constructor(props) {
    super(props);

    const {valuesForm} = props;

    let answers = []; 

    if(valuesForm && valuesForm.answerT1){
      Object.keys(valuesForm.answerT1).forEach((key) => {
        if(valuesForm.answerT1[key] && key.indexOf('answer_') > -1){
          answers.push(true);
        }
      })
    }

    if(answers.length < 4){
      answers = [true, true, true, true]
    }


    this.state = {
      answers,
      chars: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']
    }
  }
  

  isCurrent = (index) => {
    const {valuesForm, change} = this.props;
    change('answerT1.correct_answer', 'answer_' + (index + 1));
  }

  componentDidMount = () => {
    const {valuesForm} = this.props;
    let answers = []; 
    if(valuesForm && valuesForm.answerT1){
      Object.keys(valuesForm.answerT1).forEach((key) => {
        if(valuesForm.answerT1[key] && key.indexOf('answer_') > -1){
          answers.push(true);
        }
      })
    }



    if(answers.length < 4){
      answers = [true, true, true, true]
    }

    if(answers.length != this.state.answers.length){
      this.setState({answers})
    }
  };
  

  componentWillReceiveProps(nextProps){
    // const {valuesForm} = nextProps;
    // let answers = []; 
    // if(valuesForm && valuesForm.answerT1){
    //   Object.keys(valuesForm.answerT1).forEach((key) => {
    //     if(valuesForm.answerT1[key] && key.indexOf('answer_') > -1){
    //       answers.push(true);
    //     }
    //   })
    // }



    // if(answers.length < 4){
    //   answers = [true, true, true, true]
    // }

    // if(answers.length != this.state.answers.length){
    //   this.setState({answers})
    // }

  }

  resetAnswer = () => {
    this.setState({
      answers: [true, true, true, true]
    })
  }

  deleteAnswer = (index) => {
    const {formatMessage} = this.context;
    const {valuesForm, change} = this.props;
    const {answers} = this.state;

    if(answers.length == 4){
      toastr.error(formatMessage('errLimitAnswerDeleteTitle'), formatMessage('errLimitAnswerDeleteMsg'))
      return ;
    }

    const answer = 'answer_' + (index + 1);
    if(valuesForm.answerT1 && valuesForm.answerT1.correct_answer && valuesForm.answerT1.correct_answer == answer){
      change('answerT1.correct_answer', '');
    } else {
      if(valuesForm.answerT1.correct_answer){
        const indexAnswer = valuesForm.answerT1.correct_answer.replace('answer_', '') * 1;
        if(indexAnswer > index + 1){
          change('answerT1.correct_answer', 'answer_' + (indexAnswer -1))
        }
      }
    }
    
    const tmp_answer = [];


    change('answerT1.' + answer, '');

    if(valuesForm.answerT1){
      Object.keys(valuesForm.answerT1).forEach(key => {
        if(key != answer && valuesForm.answerT1[key] && key.indexOf('answer_') > -1){
          tmp_answer.push(valuesForm.answerT1[key]);
          change('answerT1.' + key, '');
        }
      })
    }

    tmp_answer.forEach((_v, _i) => {
      change('answerT1.answer_' + (_i + 1), _v);
    })


    this.setState({
      answers: answers.filter((_v, _i) => _i != index),
    })

  }

  render() {
    const isCorrect = false;
    const {valuesForm} = this.props;
    const {answers, chars} = this.state;
    const {formatMessage} = this.context
    const correct_answer = valuesForm && valuesForm.answerT1 && valuesForm.answerT1.correct_answer || '';

    return (
      <div className='Answers'>
        <div className="title">{formatMessage('Answers')}</div>
        {answers.map((_i, index) => 
          <Field
            key={'answer_' + index} 
            name={"answerT1.answer_" + (index + 1)} 
            component={AnswerInput}
            answerLabel={chars[index]}
            isCorrect={correct_answer == 'answer_' + (index+1)}
            deleteAnswer={this.deleteAnswer.bind(this, index)}
            index={index}
            correct_answer={correct_answer}
            isCurrent={this.isCurrent.bind(this, index)}
            validate={[required({message: formatMessage('Answer required')})]}
          />
        )}
        <Field name="answerT1.correct_answer" validate={[required({message: formatMessage('Correct answer is required')})]} component={ErrorMessage} />
        <div style={{display: 'flex'}}>
          <button className={classNames("question-type pull-left", {block: answers.length == 10})} type="button" onClick={() => {
            if(answers.length == 10){
              return null;
            }
            this.setState({
              answers: [...answers, true],
            }, () => {
              const el = document.getElementById('answer_text_'+(this.state.answers.length-1));
              if(el){
                el.focus();
              }
            });
          }}>
            <span className="question-type-plus-icon">+</span> {formatMessage('Add answer')}
          </button>
        </div>
      </div>
    );
  }
}

export default Answers;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ModalFormQbm/components/components/Answers.jsx